<template lang="html">
  <div>
    <div class="loader-wrap" v-if="!loaded || !loadedList">
      <div class="loader-content">
        <div class="loader">
          <div class="loader__item"></div>
        </div>
      </div>
    </div>

    <div class="content" v-else>
      <h1 v-if="type === 'add'">
        Vytváření poukazu
      </h1>
      <h1 v-else>
        Detail poukazu
      </h1>

      <v-layout>
        <table class="info-table">
          <tr v-if="type !== 'add'">
            <td class="info-table__title">
              Stav:
            </td>
            <td class="info-table__value">
              <div class="status-wrap">
                <span
                  v-if="data.valid === 'yes'"
                  class="status status--table status--success"
                  >K použití</span
                >
                <span
                  v-else-if="data.valid === 'no'"
                  class="status status--table"
                  >Použit</span
                >
                <span
                  v-else-if="data.valid === 'expired'"
                  class="status status--table status--error"
                  >Expirován</span
                >
                <span
                  v-else-if="data.valid === 'not_yet'"
                  class="status status--table status--normal"
                  >Zatím nedostupný</span
                >
              </div>
            </td>
          </tr>

          <tr v-if="type !== 'add'">
            <td class="info-table__title">
              Vytvořil:
            </td>
            <td class="info-table__value">
              <v-text-field
                v-if="
                  createdTypes.find(
                    (itemType) => itemType.type === data.created_by
                  )
                "
                disabled
                class="input--small"
                outlined
                v-model="
                  createdTypes.find(
                    (itemType) => itemType.type === data.created_by
                  ).name
                "
                @input="errors.id"
                :error-messages="makeError(errors.id)"
              >
              </v-text-field>
              <v-text-field
                v-else
                disabled
                class="input--small"
                outlined
                value="Neevidováno"
                @input="errors.id"
                :error-messages="makeError(errors.id)"
              >
              </v-text-field>
            </td>
          </tr>

          <tr v-if="type !== 'add' && data.file.path">
            <td class="info-table__title">
              <span></span>
            </td>
            <td class="info-table__value">
              <v-btn
                color="secondary"
                type="submit"
                class="button--control button--input"
                @click="downloadVoucher()"
              >
                Stáhnout .pdf
              </v-btn>
            </td>
          </tr>

          <tr v-if="type !== 'add' && !data.file.path">
            <td class="info-table__title">
              <span></span>
            </td>
            <td class="info-table__value">
              <v-btn
                color="primary"
                type="submit"
                class="button--control button--input"
                @click="prepareVoucher()"
              >
                Vygenerovat .pdf
              </v-btn>
            </td>
          </tr>

          <tr v-if="type !== 'add'">
            <td class="info-table__title">
              ID:
            </td>
            <td class="info-table__value">
              <v-text-field
                disabled
                class="input--small"
                outlined
                v-model="data.id"
                @input="errors.id"
                :error-messages="makeError(errors.id)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr v-if="type !== 'add'">
            <td class="info-table__title">
              Kód:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small input--uppercase"
                outlined
                :disabled="data.used"
                v-model="data.code"
                @input="errors.code = ''"
                :error-messages="makeError(errors.code)"
              >
              </v-text-field>
            </td>
          </tr>
          <tr>
            <td class="info-table__title">
              Typ: <span class="required-symbol">*</span>
            </td>
            <td class="info-table__value">
              <v-autocomplete
                :items="types"
                :error-messages="makeError(errors.type)"
                v-model="data.type"
                @select="errors.type = ''"
                outlined
                :disabled="data.used"
                item-value="value"
                item-text="name"
                class="input--small"
              ></v-autocomplete>
            </td>
          </tr>

          <tr v-if="data.type === 'category_percentage'">
            <td class="info-table__title">
              Kategorie: <span class="required-symbol">*</span>
            </td>
            <td class="info-table__value">
              <v-autocomplete
                :items="categories"
                :error-messages="makeError(errors.category_id)"
                v-model="data.category_id"
                @select="errors.category_id = ''"
                outlined
                :disabled="data.used"
                item-value="id"
                item-text="name"
                class="input--small"
              ></v-autocomplete>
            </td>
          </tr>
          <!-- data.type === 'audiobook_crowns' ||
                data.type === 'audiobook_percentage' ||
                data.type === 'audiobook' -->

          <tr
            v-if="
              [
                'audiobook',
                'audiobook_crowns',
                'audiobook_percentage',
                'ebook_crowns',
                'ebook_percentage',
                'book_crowns',
                'book_percentage',
                'book',
                'ebook'
              ].includes(data.type)
            "
          >
            <td class="info-table__title">
              Audiokniha: <span class="required-symbol">*</span>
            </td>
            <td class="info-table__value">
              <!-- :items="audiobooks" -->
              <v-autocomplete
                :items="itemsBySelected(data.type)"
                :error-messages="makeError(errors.audiobook_id)"
                v-model="data.audiobook_id"
                @select="errors.audiobook_id = ''"
                outlined
                :disabled="data.used"
                item-value="id"
                item-text="name"
                class="input--small"
              ></v-autocomplete>
            </td>
          </tr>

          <!-- data.type === 'crowns' || data.type === 'audiobook_crowns' -->
          <tr
            v-if="
              [
                'crowns',
                'audiobook_crowns',
                'book_crowns',
                'ebook_crowns',
              ].includes(data.type)
            "
          >
            <td class="info-table__title">
              Sleva: <span class="required-symbol">*</span><br /><span
                >(Kč)</span
              >
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--smaller"
                type="number"
                @keypress="onlyNumber"
                outlined
                :disabled="data.used"
                v-model="data.price"
                @input="errors.price = ''"
                :error-messages="makeError(errors.price)"
              >
              </v-text-field>
            </td>
          </tr>

          <!-- data.type === 'percentage' ||
                data.type === 'audiobook_percentage' ||
                data.type === 'category_percentage' -->
          <tr
            v-if="
              [
                'percentage',
                'audiobook_percentage',
                'category_percentage',
                'book_percentage',
                'ebook_percentage',
              ].includes(data.type)
            "
          >
            <td class="info-table__title">
              Sleva: <span class="required-symbol">*</span><br /><span
                >(1% - 100%)</span
              >
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--smaller"
                type="number"
                @keypress="onlyNumber"
                outlined
                :disabled="data.used"
                v-model="data.percentage"
                @input="errors.percentage = ''"
                :error-messages="makeError(errors.percentage)"
              >
              </v-text-field>
            </td>
          </tr>

          <tr v-if="type === 'add'">
            <td class="info-table__title">
              Vlastní kód:
            </td>
            <td class="info-table__value">
              <v-checkbox
                class="input--smaller"
                outlined
                v-model="data.strict_code"
                @input="errors.strict_code = ''"
                :error-messages="makeError(errors.strict_code)"
              >
              </v-checkbox>
            </td>
          </tr>

          <tr v-if="type === 'add' && data.strict_code">
            <td class="info-table__title">
              Kód: <span class="required-symbol">*</span><br /><span
                >(16 znaků)</span
              >
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                maxlength="16"
                v-model="data.strict_example"
                @input="errors.strict_example = ''"
                :error-messages="makeError(errors.strict_example)"
              >
              </v-text-field>
            </td>
          </tr>

          <tr v-if="type === 'add' && !data.strict_code">
            <td class="info-table__title">
              Začátek kódu:<br /><span>(4 znaky)</span>
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--small"
                outlined
                maxlength="4"
                v-model="data.example"
                @input="errors.example = ''"
                :error-messages="makeError(errors.example)"
              >
              </v-text-field>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Platnost od:
            </td>
            <td class="info-table__value info-table__value--date">
              <v-text-field
                class="input--small"
                outlined
                disabled
                v-model="validFrom"
                @input="errors.valid_from = ''"
                :error-messages="makeError(errors.valid_from)"
              >
              </v-text-field>

              <v-btn
                color="secondary"
                type="submit"
                class="button--table"
                @click="openDialogValidFrom()"
              >
                Změnit
              </v-btn>
              <v-btn
                color="error"
                type="submit"
                class="button--table"
                @click="data.valid_from = null"
              >
                Zrušit
              </v-btn>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Platnost do:
            </td>
            <td class="info-table__value info-table__value--date">
              <v-text-field
                class="input--small"
                outlined
                disabled
                v-model="validTo"
                @input="errors.valid_to = ''"
                :error-messages="makeError(errors.valid_to)"
              >
              </v-text-field>

              <v-btn
                color="secondary"
                type="submit"
                class="button--table"
                @click="openDialogValidTo()"
              >
                Změnit
              </v-btn>
              <v-btn
                color="error"
                type="submit"
                class="button--table"
                @click="data.valid_to = null"
              >
                Zrušit
              </v-btn>
            </td>
          </tr>

          <tr v-if="!data.infinite && type === 'add' && !data.strict_code">
            <td class="info-table__title">
              Počet kusů:
            </td>
            <td class="info-table__value">
              <v-text-field
                class="input--smaller"
                type="number"
                @keypress="onlyNumber"
                outlined
                v-model="data.count"
                @input="errors.count = ''"
                :error-messages="makeError(errors.count)"
              >
              </v-text-field>
            </td>
          </tr>

          <tr v-if="type === 'add'">
            <td class="info-table__title">
              Neomezeně:
            </td>
            <td class="info-table__value">
              <v-checkbox
                class="input--smaller"
                outlined
                v-model="data.infinite"
                @input="errors.infinite = ''"
                :error-messages="makeError(errors.infinite)"
              >
              </v-checkbox>
            </td>
          </tr>

          <tr>
            <td class="info-table__title">
              Poznámka:
            </td>
            <td class="info-table__value">
              <v-textarea
                class="input--larger"
                outlined
                v-model="data.note"
                @input="errors.note = ''"
                :error-messages="makeError(errors.note)"
              >
              </v-textarea>
            </td>
          </tr>
        </table>
      </v-layout>
      <v-layout>
        <div class="controls-table">
          <v-btn
            color="primary"
            type="submit"
            class="button--control"
            @click="addVoucher()"
            v-if="type === 'add'"
          >
            Vytvořit
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            class="button--control"
            @click="editVoucher()"
            v-else
          >
            Uložit
          </v-btn>
          <v-btn
            color="error"
            class="button--control"
            @click="openDialogDelete()"
            v-if="type !== 'add'"
          >
            Smazat
          </v-btn>
        </div>
      </v-layout>
      <v-layout>
        <div>
          <h2>Cena objednávek při použití poukazu bez slevy</h2>
          <span class="actual-price">
            <span v-if="orders && orders.length">
              {{
                orders
                  .reduce(
                    (sum, { order_price_voucher }) =>
                      sum + parseFloat(order_price_voucher),
                    0
                  )
                  .toFixed(2)
              }}
              Kč
            </span>
            <span v-else>
              0 Kč
            </span>
          </span>
          <br />
          <span v-if="orders && orders.length" class="normal small"
            ><span class="small">Bez DPH</span>
            {{
              orders
                .reduce(
                  (sum, { order_price_voucher }) =>
                    sum + parseFloat(order_price_voucher) * 0.9,
                  0
                )
                .toFixed(2)
            }}
            Kč</span
          >
          <span v-else class="normal small"
            ><span class="small">Bez DPH</span> 0 Kč</span
          >
        </div>
      </v-layout>

      <v-dialog v-model="dialogDelete" persistent>
        <v-card>
          <v-card-title class="headline">Smazání poukazu</v-card-title>
          <v-card-text>
            Opravdu si přejete smazat poukaz <strong>{{ data.name }}</strong
            >?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="empty"
              class="button--dialog"
              @click="closeDialogDelete()"
            >
              zrušit
            </v-btn>
            <v-btn
              color="error"
              class="button--dialog"
              @click="deleteVoucher()"
            >
              smazat
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogValidFrom" persistent>
        <v-card>
          <v-card-title class="headline">Platnost od</v-card-title>
          <v-date-picker
            v-model="data.valid_from"
            locale="cs-cz"
            :max="data.valid_to"
            @click:date="closeDialogValidFrom()"
          ></v-date-picker>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="empty"
              class="button--dialog"
              @click="closeDialogValidFrom()"
            >
              zrušit
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogValidTo" persistent>
        <v-card>
          <v-card-title class="headline">Platnost do</v-card-title>
          <v-date-picker
            :min="data.valid_from"
            locale="cs-cz"
            v-model="data.valid_to"
            @click:date="closeDialogValidTo()"
          ></v-date-picker>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="empty"
              class="button--dialog"
              @click="closeDialogValidTo()"
            >
              zrušit
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "VouchersDetail",
  components: {},

  data() {
    return {
      orders: [],
      dialogDelete: false,
      type: "add",
      loaded: false,
      loadedList: false,
      data: {},
      errors: {},
      types: [
        { value: "audiobook", name: "Audiokniha zdarma" },
        { value: "audiobook_percentage", name: "Sleva v % na audioknihu" },
        { value: "audiobook_crowns", name: "Sleva v Kč na audioknihu" },
        { value: "book", name: "Tištěná kniha zdarma" },
        { value: "book_percentage", name: "Sleva v % na tištěnou knihu" },
        { value: "book_crowns", name: "Sleva v Kč na tištěnou knihu" },
        { value: "ebook", name: "E-kniha zdarma" },
        { value: "ebook_percentage", name: "Sleva v % na e-knihu" },
        { value: "ebook_crowns", name: "Sleva v Kč na e-knihu" },
        { value: "percentage", name: "Sleva v % na nákup" },
        { value: "crowns", name: "Sleva v Kč na nákup" },
        { value: "category_percentage", name: "Sleva v % na kategorii" },
      ],
      createdTypes: [
        {
          type: "all",
          name: "Všechny",
        },
        {
          type: "no_activity_6_months",
          name: "Neaktivita 6 měsíců",
        },
        {
          type: "no_activity_3_months",
          name: "Neaktivita 3 měsíce",
        },
        {
          type: "birthday",
          name: "Narozeniny",
        },
        {
          type: "order",
          name: "Objednávka",
        },
        {
          type: "review_book",
          name: "Recenze audioknihy",
        },
        {
          type: "admin",
          name: "Admin",
        },
      ],
      categories: [],
      audiobooks: [],
      dialogValidTo: false,
      dialogValidFrom: false,
    };
  },

  created() {
    //  this.fetchData();
    this.fetchDataLists();
  },
  computed: {
    ...mapState(["profile"]),
    validTo() {
      if (this.data.valid_to) {
        return moment(this.data.valid_to).format("DD.MM.YYYY");
      } else {
        return null;
      }
    },
    validFrom() {
      if (this.data.valid_from) {
        return moment(this.data.valid_from).format("DD.MM.YYYY");
      } else {
        return null;
      }
    },
  },
  mounted() {},
  methods: {
    itemsBySelected(t) {
      let items = [];
      switch (t) {
        case "audiobook":
        case "audiobook_crowns":
        case "audiobook_percentage":
          items = this.audiobooks.filter((v) => {
            return !v.is_ebook && !v.is_book;
          });
          break;
        case "ebook":
        case "ebook_crowns":
        case "ebook_percentage":
          items = this.audiobooks.filter((v) => v.is_ebook);
          break;
        case "book":
        case "book_crowns":
        case "book_percentage":
          items = this.audiobooks.filter((v) => v.is_book);
          break;
        default:
          break;
      }

      return items;
    },
    makeError(item) {
      if (item === "required") {
        return "Toto pole je povinné";
      } else if (item === "already_used") {
        return "Je již používaný";
      } else if (item === "not_valid") {
        return "Neplatný formát";
      } else if (item === "max_price") {
        return "Překročena cena knihy";
      } else if (item === "not_in_range") {
        return "Není v rozmezí 1 - 100";
      } else if (item === "code_exists") {
        return "Kód již existuje";
      } else if (item) {
        return "Neznámá chyba";
      } else {
        return "";
      }
    },
    openDialogValidTo() {
      this.dialogValidTo = true;
    },
    closeDialogValidTo() {
      this.dialogValidTo = false;
    },
    openDialogValidFrom() {
      this.dialogValidFrom = true;
    },
    closeDialogValidFrom() {
      this.dialogValidFrom = false;
    },
    openDialogDelete() {
      this.dialogDelete = true;
    },
    closeDialogDelete() {
      this.dialogDelete = false;
    },
    addVoucher() {
      this.loaded = false;
      const request = this.data;
      this.$axios
        .post("/admin/vouchers/add", request)
        .then((response) => {
          this.$router.push({ name: "Vouchers" });
        })
        .catch((e) => {
          if (e.response.data.error_inputs) {
            this.errors = e.response.data.error_inputs;
          }
          this.loaded = true;
        });
    },
    downloadVoucher() {
      if (this.data.file) {
        const link = document.createElement("a");
        link.href = this.data.file.path;
        link.target = "_blank";
        link.setAttribute("download", this.data.file.name); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    },
    prepareVoucher() {
      this.loaded = false;
      const request = this.data;
      this.$axios
        .post("/admin/vouchers/" + this.$route.params.id + "/prepare", request)
        .then((response) => {
          this.fetchData();
          this.loaded = true;
        })
        .catch((e) => {
          this.errors = e.response.data.error_inputs;
          this.loaded = true;
        });
    },
    editVoucher() {
      this.loaded = false;
      const request = this.data;
      this.$axios
        .put("/admin/vouchers/" + this.$route.params.id + "/edit", request)
        .then((response) => {
          this.$router.push({ name: "Vouchers" });
        })
        .catch((e) => {
          this.errors = e.response.data.error_inputs;
          this.loaded = true;
        });
    },
    deleteVoucher() {
      this.loaded = false;
      const request = this.data;
      this.$axios
        .delete("/admin/vouchers/" + this.$route.params.id + "/delete", request)
        .then((response) => {
          this.$router.push({ name: "Vouchers" });
        })
        .catch((e) => {
          this.loaded = true;
        });
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    fetchData() {
      if (this.$route.params.id === "add") {
        this.type = "add";
        this.data = {};
        this.loaded = true;
      } else {
        this.type = "detail";
        this.$axios
          .get("/admin/vouchers/" + this.$route.params.id)
          .then((response) => {
            this.type = "detail";
            this.data = response.data.voucher;
            if (response.data.voucher.valid_to) {
              this.data.valid_to = moment
                .unix(response.data.voucher.valid_to)
                .format("YYYY-MM-DD");
            }
            if (response.data.voucher.valid_from) {
              this.data.valid_from = moment
                .unix(response.data.voucher.valid_from)
                .format("YYYY-MM-DD");
            }
            this.orders = response.data.orders;

            this.orders.forEach((order) => {
              let order_price = 0;
              order.order_items.forEach((item) => {
                if (item.type !== "voucher") {
                  order_price += parseFloat(item.price);
                }
              });
              order.order_price_voucher = order_price;
            });
            this.loaded = true;
          })
          .catch((e) => {
            this.$router.push({ name: "Vouchers" });
            this.loaded = true;
          });
      }
    },
    fetchDataLists() {
      this.$axios
        .get("/admin/vouchers/data")
        .then((response) => {
          function sortComparer(a, b) {
            return a.name.localeCompare(b.name);
          }
          let audiobooks = response.data.audiobooks;
          audiobooks.sort(function(a, b) {
            return sortComparer(a, b);
          });

          this.audiobooks = audiobooks.map(it => {
            let type = ' (Audiokniha)';
            if(it.is_ebook) type = ' (E-kniha)'
            if(it.is_book) type = ' (Kniha)'
            it.name += type;
            return it;
          });
          this.categories = response.data.categories;
          this.loadedList = true;

          this.fetchData();
        })
        .catch((e) => {
          this.fetchData();
          this.loadedList = true;
        });
    },
  },
  watch: {},
};
</script>

<style lang="scss"></style>
